import Page from "../Common/Page";
import React from "react";
import {
  Form,
  Radio,
  Select,
  Button,
  Row,
  Col,
  Table,
  Space,
  Upload,
  Tooltip,
  message,
} from "antd";
import { QuestionCircleOutlined, UploadOutlined } from "@ant-design/icons";
import { Messages } from "../Common/ValidateMessages";
import { http, httpForm, httpForBlob } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import moment from "moment";
import { JudgmentUnitSelecter } from "../Components/JudgmentUnitSelecter";
import { getSubjectOptions } from "../Common/Utils";

const { Option } = Select;

interface PostCountData {
  process: string;
  fy: string;
}

interface PostTemplateData {
  process: string;
  judgmentUnit: string;
  subject: string;
  fy: string;
}

interface PostExportData {
  process: string;
  judgmentUnit: string;
  subject: string;
  fy: string;
}

interface ReminderDataFromServer {
  status: number;
  examinationData: [];
  errList: [];
  CompleteCnt: "";
  UploadDateTime: "";
  numberOfCSVData: number;
  numberOfSuccesses: number;
  numberOfFailures: number;
}
interface CountDataFromServer {
  completeCnt: string;
  uploadDateTime: string;
}

export class ScorePassfailurePage extends React.Component<any, any> {
  static contextType = AuthContext;

  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;

  constructor(props: any, context) {
    super(props);
    this._page = React.createRef<Page>();
    this._form = React.createRef();

    this.state = {
      defaultFy: context.user.currentYear.toString(),
      judgmentUnit: "",
      process: "",
      type: "",
      subjectOptions: [],
      fileList: [],
      processResults: [],
      CntInfomation: "none",
      Cnt: "",
      Update: "",
      importInfomation: "",
    };
  }

  // 得点・合否結果出力処理
  doProcess1 = async (formValues: any) => {
    let api_path = "/JudgmentResultExport/Export";
    let DownloadFile = "Judgment.csv";

    const reminderData: PostTemplateData = {
      process: "",
      judgmentUnit: "",
      subject: "",
      fy: formValues.fy["value"],
    };

    if (
      formValues.judgmentUnit !== undefined &&
      formValues.judgmentUnit.length > 0
    ) {
      reminderData.judgmentUnit = formValues.judgmentUnit;
    }
    try {
      this._page.current?.setState({ isPageLoading: true });

      const result = await httpForBlob({
        path: api_path,
        method: "post",
        accessToken: this.context.accessToken,
        body: reminderData,
      });

      if (result.size > 0) {
        const csvfile = window.URL.createObjectURL(result);
        await fetch(csvfile);
        const link = document.createElement("a");
        link.href = csvfile;
        link.download = DownloadFile;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        // 試験データが1件もない場合のメッセージ
        message.error(Messages["ERR-019"]);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      message.error(Messages["ERR-028"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  // 得点取込処理
  doProcess2 = async (formValues: any) => {
    // TODO:　得点取込処理
    let api_path = "";
    let DownloadFile = "";

    if (formValues.type === "1") {
      api_path = "/ScoreImport/Template";
      DownloadFile = "ScoreTemplate.csv";
    }
    if (formValues.type === "2" || this.state.type === "2") {
      api_path = "/ScoreImport/Upload";
    }
    if (formValues.type === "3") {
      api_path = "/ScoreImport/Export";
      DownloadFile = "ExaminationApplicant.csv";
    }

    // 得点テンプレートダウンロード
    if (formValues.type === "1") {
      const reminderData: PostTemplateData = {
        process: "",
        judgmentUnit: "",
        subject: "",
        fy: formValues.fy["value"],
      };

      if (
        formValues.judgmentUnit !== undefined &&
        formValues.judgmentUnit.length > 0
      ) {
        reminderData.judgmentUnit = formValues.judgmentUnit;
      }
      if (
        formValues.SubjectCode !== undefined &&
        formValues.SubjectCode.length > 0
      ) {
        reminderData.subject = formValues.SubjectCode;
      }

      try {
        this._page.current?.setState({ isPageLoading: true });

        const result = await httpForBlob({
          path: api_path,
          method: "post",
          accessToken: this.context.accessToken,
          body: reminderData,
        });

        if (result.size > 0) {
          const csvfile = window.URL.createObjectURL(result);
          await fetch(csvfile);
          const link = document.createElement("a");
          link.href = csvfile;
          link.download = DownloadFile;
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          // 試験データが1件もない場合のメッセージ
          message.error(Messages["ERR-019"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        message.error(Messages["ERR-028"]);
        this._page.current?.setState({ isPageLoading: false });
      }
    }
    // 得点インポート
    else if (formValues.type === "2" || this.state.type === "2") {
      const { fileList } = this.state;

      this.setState({
        processResults: [],
      });

      if (fileList.length === 0) {
        // CSVが指定されていないとき
        message.error(Messages["ERR-021"]);
      } else {
        const PostData = new FormData();
        // PostData.append("type", "2");
        PostData.append("FormFiles", fileList[0]);

        try {
          this._page.current?.setState({ isPageLoading: true });
          const result = await httpForm<ReminderDataFromServer>(
            {
              path: api_path,
              method: "post",
              accessToken: this.context.accessToken,
            },
            PostData
          );
          if (result.ok && result.body) {
            // CSVアップロード処理完了メッセージ
            // 全件XX件、成功XX件、失敗XX件 result.body.numberOfCSVData result.body.numberOfSuccesses result.body.numberOfFailures
            const Msg = ` :全件${result.body.numberOfCSVData}件、成功${result.body.numberOfSuccesses}件、失敗${result.body.numberOfFailures}件`;
            this.setState({
              importInfomation: Msg,
              fileList: [],
              processResults: result.body.errList,
            });
            message.info(Messages["MSG-002"]);
          } else {
            if (result.body?.status === 400) {
              // ShiftJISではない
              message.error(Messages["ERR-022"]);
            } else {
              // その他エラー
              message.error(Messages["ERR-020"]);
            }
          }
          this._page.current?.setState({ isPageLoading: false });
          this.setState({ CSVDisabled: false });
        } catch (error) {
          message.error(Messages["ERR-028"]);
          this._page.current?.setState({ isPageLoading: false });
        }
      }
    }
    // 得点エクスポート
    else if (formValues.type === "3") {
      const reminderData: PostExportData = {
        process: "",
        judgmentUnit: "",
        subject: "",
        fy: formValues.fy["value"],
      };
      if (
        formValues.judgmentUnit !== undefined &&
        formValues.judgmentUnit.length > 0
      ) {
        reminderData.judgmentUnit = formValues.judgmentUnit;
      }
      if (
        formValues.SubjectCode !== undefined &&
        formValues.SubjectCode.length > 0
      ) {
        reminderData.subject = formValues.SubjectCode;
      }
      try {
        this._page.current?.setState({ isPageLoading: true });
        const result = await httpForBlob({
          path: api_path,
          method: "post",
          accessToken: this.context.accessToken,
          body: reminderData,
        });
        if (result.size > 0) {
          const csvfile = window.URL.createObjectURL(result);
          await fetch(csvfile);
          const link = document.createElement("a");
          link.href = csvfile;
          link.download = DownloadFile;
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          // 試験データが1件もない場合のメッセージ
          message.error(Messages["ERR-019"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        message.error(Messages["ERR-028"]);
        this._page.current?.setState({ isPageLoading: false });
      }
    }
  };

  // 合否結果取込処理
  doProcess3 = async (formValues: any) => {
    // 合否結果取込処理
    let api_path = "";
    let DownloadFile = "";

    if (formValues.type === "1") {
      api_path = "/PassFailureResultImport/Template";
      DownloadFile = "PassFailureResultTemplate.csv";
    }
    if (formValues.type === "2" || this.state.type === "2") {
      api_path = "/PassFailureResultImport/Upload";
    }
    if (formValues.type === "3") {
      api_path = "/PassFailureResultImport/Export";
      DownloadFile = "PassFailureResult.csv";
    }

    if (formValues.type === "1") {
      const reminderData: PostTemplateData = {
        process: "",
        judgmentUnit: "",
        subject: "",
        fy: formValues.fy["value"],
      };
      if (
        formValues.judgmentUnit !== undefined &&
        formValues.judgmentUnit.length > 0
      ) {
        reminderData.judgmentUnit = formValues.judgmentUnit;
      }
      if (
        formValues.SubjectCode !== undefined &&
        formValues.SubjectCode.length > 0
      ) {
        reminderData.subject = formValues.SubjectCode;
      }
      try {
        this._page.current?.setState({ isPageLoading: true });
        const result = await httpForBlob({
          path: api_path,
          method: "post",
          accessToken: this.context.accessToken,
          body: reminderData,
        });

        if (result.size > 0) {
          const csvfile = window.URL.createObjectURL(result);
          await fetch(csvfile);
          const link = document.createElement("a");
          link.href = csvfile;
          link.download = DownloadFile;
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          // 試験データが1件もない場合のメッセージ
          message.error(Messages["ERR-019"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        message.error(Messages["ERR-028"]);
        this._page.current?.setState({ isPageLoading: false });
      }
    } else if (formValues.type === "2" || this.state.type === "2") {
      const { fileList } = this.state;

      this.setState({
        processResults: [],
      });

      if (fileList.length === 0) {
        // CSVが指定されていないとき
        message.error(Messages["ERR-021"]);
        this._page.current?.setState({ isPageLoading: false });
      } else {
        const PostData = new FormData();
        PostData.append("FormFiles", fileList[0]);
        try {
          this._page.current?.setState({ isPageLoading: true });
          const result = await httpForm<ReminderDataFromServer>(
            {
              path: api_path,
              method: "post",
              accessToken: this.context.accessToken,
            },
            PostData
          );
          if (result.ok && result.body) {
            // CSVアップロード処理完了メッセージ
            const Msg = ` :全件${result.body.numberOfCSVData}件、成功${result.body.numberOfSuccesses}件、失敗${result.body.numberOfFailures}件`;
            this.setState({
              importInfomation: Msg,
              fileList: [],
              processResults: result.body.errList,
            });
            message.info(Messages["MSG-002"]);
          } else {
            if (result.body?.status === 400) {
              // ShiftJISではない
              message.error(Messages["ERR-022"]);
            } else {
              // その他エラー
              message.error(Messages["ERR-020"]);
            }
          }
          this._page.current?.setState({
            isPageLoading: false,
          });
          this.setState({ CSVDisabled: false });
        } catch (error) {
          message.error(Messages["ERR-028"]);
          this._page.current?.setState({ isPageLoading: false });
        }
      }
    } else if (formValues.type === "3") {
      const reminderData: PostExportData = {
        process: "",
        judgmentUnit: "",
        subject: "",
        fy: formValues.fy["value"],
      };
      if (
        formValues.judgmentUnit !== undefined &&
        formValues.judgmentUnit.length > 0
      ) {
        reminderData.judgmentUnit = formValues.judgmentUnit;
      }
      if (
        formValues.SubjectCode !== undefined &&
        formValues.SubjectCode.length > 0
      ) {
        reminderData.subject = formValues.SubjectCode;
      }
      try {
        this._page.current?.setState({ isPageLoading: true });
        const result = await httpForBlob({
          path: api_path,
          method: "post",
          accessToken: this.context.accessToken,
          body: reminderData,
        });

        if (result.size > 0) {
          const csvfile = window.URL.createObjectURL(result);
          await fetch(csvfile);
          const link = document.createElement("a");
          link.href = csvfile;
          link.download = DownloadFile;
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          // 試験データが1件もない場合のメッセージ
          message.error(Messages["ERR-019"]);
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        message.error(Messages["ERR-028"]);
        this._page.current?.setState({ isPageLoading: false });
      }
    }
  };

  // 採点結果出力(採点者ごと)処理
  doProcess4 = async (formValues: any) => {
    let api_path = "/ScoreCommentExport/Export";
    let DownloadFile = "ScoreComment.csv";

    const reminderData: PostTemplateData = {
      process: "",
      judgmentUnit: "",
      subject: "",
      fy: formValues.fy["value"],
    };

    if (
      formValues.judgmentUnit !== undefined &&
      formValues.judgmentUnit.length > 0
    ) {
      reminderData.judgmentUnit = formValues.judgmentUnit;
    }
    try {
      this._page.current?.setState({ isPageLoading: true });

      const result = await httpForBlob({
        path: api_path,
        method: "post",
        accessToken: this.context.accessToken,
        body: reminderData,
      });

      if (result.size > 0) {
        const csvfile = window.URL.createObjectURL(result);
        await fetch(csvfile);
        const link = document.createElement("a");
        link.href = csvfile;
        link.download = DownloadFile;
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        // 試験データが1件もない場合のメッセージ
        message.error(Messages["ERR-019"]);
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      message.error(Messages["ERR-028"]);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onGoButtonClick = async () => {
    // 処理未選択
    if (this.state.process === "") {
      try {
        await this._form.current.validateFields(["process"]);
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }

    let formValues;
    // 得点・合否判定結果出力の場合
    if (this.state.process === "1") {
      try {
        formValues = await this._form.current.validateFields([
          "fy",
          "judgmentUnit",
        ]);
        await this.doProcess1(formValues);
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }
    // 得点の場合
    else if (this.state.process === "2") {
      try {
        if (this.state.type === "2") {
          formValues = await this._form.current.validateFields(["FormFiles"]);
        } else {
          formValues = await this._form.current.validateFields([
            "type",
            "fy",
            "judgmentUnit",
            "SubjectCode",
          ]);
        }
        await this.doProcess2(formValues);
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }
    // 合否結果の場合
    else if (this.state.process === "3") {
      try {
        if (this.state.type === "2") {
          formValues = await this._form.current.validateFields(["FormFiles"]);
        } else {
          formValues = await this._form.current.validateFields([
            "type",
            "fy",
            "judgmentUnit",
          ]);
        }
        await this.doProcess3(formValues);
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }
    // 採点結果出力(採点者ごと)の場合
    else if (this.state.process === "4") {
      try {
        formValues = await this._form.current.validateFields([
          "fy",
          "judgmentUnit",
        ]);
        await this.doProcess4(formValues);
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }
    }
  };

  onFyChange = (newValue) => {
    this.setState({
      defaultFy: newValue.value,
    });
  };

  onJudgmentUnitSelected = async (record: any) => {
    // console.log("Success:", record);
    if (record) this.setState({ judgmentUnit: record.fyJudgementUnitId });
    else this.setState({ judgmentUnit: undefined });

    if (
      this.state.process === "2" &&
      record &&
      record.fyJudgementUnitId &&
      record.fyJudgementUnitId.length > 0
    ) {
      const subjectOptions = await getSubjectOptions(
        this.context.accessToken,
        record.fyJudgementUnitId,
        "1",
        undefined,
        undefined
      );
      this.setState({
        subjectOptions: subjectOptions,
        subject: "",
      });
    } else {
      this.setState({
        subjectOptions: [],
        subject: "",
      });
    }
  };

  onTypeChange = (e) => {
    this.setState({
      processResults: [],
      type: e.target.value,
    });
  };

  onFormValueChange = () => {
    this.setState({
      importInfomation: "",
      processResults: [],
    });
  };

  changeProcess = async (value: any) => {
    if (value === "2" || value === "3") {
      try {
        this._page.current?.setState({ isPageLoading: true });
        const reminderData: PostCountData = {
          process: String(value),
          fy: this.state.defaultFy,
        };
        const result = await http<CountDataFromServer, PostCountData>({
          path: "/ExamFileImport/ScoreCapture",
          method: "post",
          body: reminderData,
          accessToken: this.context.accessToken,
        });
        if (result.ok && result.body) {
          // APIからゲットしたものを設定
          const cnt = Number(result.body.completeCnt).toLocaleString();
          let datestr = result.body.uploadDateTime;
          if (datestr !== undefined && datestr != null && datestr.length > 0) {
            datestr = moment(datestr).format("yyyy/MM/DD HH:mm:SS");
          } else {
            datestr = "";
          }
          this.setState({
            Cnt: cnt,
            Update: datestr,
          });
          this.setState({ CntInfomation: "" });
        } else {
          this.setState({ CntInfomation: "none" });
        }
        this._page.current?.setState({ isPageLoading: false });
      } catch (error) {
        console.log(error);
        this.setState({ CntInfomation: "none" });
        this._page.current?.setState({ isPageLoading: false });
      }
    } else {
      this.setState({ CntInfomation: "none" });
    }

    this.setState({
      processResults: [],
      defaultFy: this.context.user.currentYear.toString(),
      process: value,
      type: "1",
    });
    this._form.current.setFieldsValue({
      type: "1",
      fy: {
        value: this.context.user.currentYear.toString(),
        label: this.context.user.currentYear.toString(),
      },
    });
  };

  fixedColumns = [
    {
      title: "行番号",
      dataIndex: "lineNo",
      fixed: true,
      width: 100,
    },
    {
      title: "カラム名",
      dataIndex: "column",
      fixed: true,
      width: 100,
    },
    {
      title: "エラー内容",
      dataIndex: "errMessage",
    },
  ];

  validatorForFy = async (_: any, value: any): Promise<void> => {
    const currentYear = Number(this.context.user.currentYear);
    if (
      this.state.process !== "1" &&
      value.value !== String(currentYear) &&
      value.value !== String(currentYear - 1)
    ) {
      return Promise.reject(new Error("操作できる入試年度ではありません。"));
    }
    return Promise.resolve();
  };

  render() {
    const { fileList } = this.state;
    const uploadProps = {
      onRemove: (file: any) => {
        this.setState({
          fileList: [],
          CSVDisabled: false,
        });
      },
      beforeUpload: (file: any) => {
        const isCsv =
          file.type === "text/csv" || file.type === "application/vnd.ms-excel";
        if (!isCsv) {
          message.error(Messages["ERR-021"]);
          return false;
        }
        this.setState((state: any) => ({
          fileList: [...state.fileList, file],
          CSVDisabled: true,
        }));

        return false;
      },
      fileList,
    };
    return (
      <Page title="得点・合否結果" ref={this._page}>
        <div className="data_content" style={{ marginTop: "10px" }}>
          <Form
            colon={false}
            name="applicant"
            layout="horizontal"
            labelAlign="left"
            onValuesChange={this.onFormValueChange}
            autoComplete="off"
            className="login-form"
            encType="multipart/form-data"
            ref={this._form}
          >
            <Row>
              <Col span={6}>
                <Form.Item
                  name="process"
                  label="処理選択"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    style={{ width: "200px" }}
                    onChange={this.changeProcess}
                  >
                    <Option value="2">得点取込</Option>
                    <Option value="3">合否判定結果取込</Option>
                    <Option value="1">得点・判定結果出力</Option>
                    <Option value="4">採点結果出力(採点者ごと)</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Row style={{ display: this.state.CntInfomation }}>
                  <Col span={8}>
                    {this.context.user.currentYear}年度{this.state.Cnt}
                    件登録されています
                  </Col>
                  <Col span={8}>最終更新日時:{this.state.Update}</Col>
                </Row>
              </Col>
            </Row>
            <Row
              style={{
                display:
                  this.state.process.length > 0 &&
                  this.state.process !== "1" &&
                  this.state.process !== "4"
                    ? ""
                    : "none",
              }}
            >
              <Col span={24}>
                <Form.Item
                  name="type"
                  label="処理内容"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Radio.Group
                    onChange={this.onTypeChange}
                    value={this.state.type}
                    disabled={this.state.TypeDisabled}
                  >
                    <Space>
                      <Radio value="1">
                        テンプレートダウンロード
                        <span className="tooltip-icon">
                          <Tooltip
                            placement="right"
                            title="新規データをインポートする場合は、テンプレートファイルをダウンロード後、インポートを行ってください"
                          >
                            <QuestionCircleOutlined />
                          </Tooltip>
                        </span>
                      </Radio>
                      <Radio value="2">
                        インポート
                        <span className="tooltip-icon">
                          <Tooltip
                            placement="right"
                            title="システムへのデータ登録/修正/削除を行います"
                          >
                            <QuestionCircleOutlined />
                          </Tooltip>
                        </span>
                      </Radio>
                      <Radio value="3">
                        エクスポート
                        <span className="tooltip-icon">
                          <Tooltip
                            placement="right"
                            title={
                              <p>
                                登録されているデータをダウンロードします。
                                <br />
                                ※登録済データを更新/削除する場合は、エクスポート後、CSVの先頭カラムの値を
                                [2:更新] や [3:削除]
                                それぞれの値に変更の上、データ修正を行った後、上記インポートを行います。
                              </p>
                            }
                          >
                            <QuestionCircleOutlined />
                          </Tooltip>
                        </span>
                      </Radio>
                    </Space>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
            <Row
              style={{
                display:
                  this.state.process !== "1" &&
                  this.state.process !== "4" &&
                  this.state.type === "2"
                    ? ""
                    : "none",
              }}
            >
              <Col span={8}>
                <Form.Item
                  label="CSVファイル"
                  name="FormFiles"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Upload
                    {...uploadProps}
                    name=""
                    disabled={this.state.UploadDisabled}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      disabled={this.state.CSVDisabled}
                    >
                      ファイル選択
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>
            <Row
              style={{
                display:
                  this.state.process === "1" ||
                  this.state.process === "4" ||
                  (this.state.process !== "" && this.state.type !== "2")
                    ? ""
                    : "none",
              }}
            >
              <Col span={4}>
                <Form.Item
                  label="入試年度"
                  name="fy"
                  rules={[
                    {
                      required: true,
                    },
                    {
                      validator: this.validatorForFy,
                    },
                  ]}
                >
                  <CommonMasterSelect
                    width={80}
                    allowClear={false}
                    masterType={31}
                    onChange={this.onFyChange}
                  />
                </Form.Item>
              </Col>
              <Col span={15}>
                <Form.Item label="判定単位" name="judgmentUnit">
                  <JudgmentUnitSelecter
                    width={500}
                    defaultFy={this.state.defaultFy}
                    onDataSelect={this.onJudgmentUnitSelected}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row
              style={{
                display:
                  this.state.process === "2" && this.state.type !== "2"
                    ? ""
                    : "none",
              }}
            >
              <Col span={6}>
                <Form.Item label="科目選択" name="SubjectCode">
                  <Select allowClear={false} style={{ width: 160 }}>
                    {this.state.subjectOptions.length > 0 &&
                      this.state.subjectOptions.map((data: any) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={18}>
                <Form.Item>
                  <div style={{ display: "flex" }}>
                    <Button
                      type="primary"
                      style={{ marginLeft: "420px" }}
                      onClick={this.onGoButtonClick}
                    >
                      処理実行
                    </Button>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <h3>処理結果{this.state.importInfomation}</h3>
          <Table
            rowKey={(record: any) => record.index}
            columns={this.fixedColumns}
            dataSource={this.state.processResults}
            pagination={false}
            scroll={{ y: "calc(100vh - 360px)" }}
            bordered
          />

          <br />
          <br />
        </div>
      </Page>
    );
  }
}
